module.exports = __webpack_public_path__ + "img/category-favorite-hover.feb6cfc4.png";